import { render, staticRenderFns } from "./SimpleTotals.vue?vue&type=template&id=51a66dde"
import script from "./SimpleTotals.vue?vue&type=script&lang=js"
export * from "./SimpleTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports